module.exports = __webpack_public_path__ + "img/wizard_main_bg.98203fb9.png";